<template>
  <div>
    <p class="h3 mb-2 pt-2 pb-4">Dans quel département habitez-vous ?</p>

    <div class="row two-parts">
      <div class="col-lg-7">
        <MapDepartments :departments="departments"></MapDepartments>
      </div>
      <div class="col-lg-5 px-4 text-center d-flex flex-column justify-content-center">
        <div class="form-group">
          <select class="form-control" id="exampleFormControlSelect1" v-model="state.selected_region">
            <option :value="null" disabled>Sélectionnez votre département</option>
            <option v-for="dep in departments" :value="dep">{{dep.id}} - {{ dep.title }}</option>
          </select>
        </div>
        <template v-if="state.selected_region">
          <p class="text-secondary">La température minimale dans<br>votre département est de</p>
          <p class="h1 mb-4">{{state.selected_region.temp}} °C</p>
        </template>
        <template v-else>
          <p class="text-secondary">La température minimale de votre région <br>influera sur la puissance nécessaire</p>
        </template>

        <router-link :to="{name:'RoomType'}" tag="button" class="btn btn-md btn-primary rounded-pill w-100" :disabled="!state.selected_region">
          Étape suivante
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MapDepartments from "@/components/Map";
import json from '../../departments.json'

export default {
  name: "RegionSelection",
  components:{
    MapDepartments
  },
  data(){
    return {
      departments:json,
    }
  }
}
</script>

<style scoped>

</style>